/* Apparitions au défilement sur tout le site : titres mot par mot,
   textes, images et cartes. Le quiz, la zone d'achat des fiches produit
   et les formulaires sont laissés tranquilles, parce qu'ils changent
   d'état et qu'une apparition y gênerait plus qu'autre chose. */
(function () {
  var root = document.documentElement;
  var done = function () { root.classList.remove('rv-pending'); };
  if (window.Shopify && Shopify.designMode) return done();
  if (!('IntersectionObserver' in window)) return done();
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return done();

  var SKIP = '.rq, .rpp, product-info, .product, cart-items, cart-drawer, form, .rv-skip, [data-rv-skip]';
  var TEXT = 'h1, h2, h3, h4, p, blockquote, li, dt, dd, tr, .button, .rp__btn, [class*="eyebrow"], [class*="kicker"]';
  var MEDIA = 'img, picture, video, svg';
  var WORDS = 'h1, h2';

  function visible(el) {
    if (!el.getClientRects().length) return false;
    var cs = getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'contents' && +cs.opacity > 0;
  }
  function marked(el, scope) {
    for (var p = el.parentElement; p && p !== scope; p = p.parentElement) {
      if (p.classList.contains('rv')) return true;
    }
    return false;
  }
  function splitWords(el) {
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          if (!n.nodeValue.trim()) return;
          var frag = document.createDocumentFragment();
          n.nodeValue.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var s = document.createElement('span');
            s.className = 'rv-w';
            s.style.setProperty('--rv-i', Math.min(i++, 20));
            s.textContent = part;
            frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !/^(BR|SVG|IMG)$/i.test(n.tagName)) {
          walk(n);
        }
      });
    })(el);
    return i > 0;
  }

  var io = new IntersectionObserver(function (entries) {
    var batch = entries.filter(function (e) { return e.isIntersecting; });
    batch.forEach(function (e, k) {
      var el = e.target;
      io.unobserve(el);
      el.style.setProperty('--rv-d', Math.min(k * 90, 540) + 'ms');
      el.classList.add('rv--in');
      // Une fois arrivé, l'élément redevient normal (survols, etc.).
      setTimeout(function () { finish(el); }, 2400);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function finish(el) {
    el.classList.remove('rv', 'rv--in', 'rv--media', 'rv--card', 'rv--words');
    el.style.removeProperty('--rv-d');
  }

  function mark(el, kind) {
    el.classList.add('rv');
    if (kind) el.classList.add('rv--' + kind);
  }

  function scan(scope) {
    if (!scope || scope.closest(SKIP)) return;
    var list = [];

    // Cartes : les enfants d'une grille montent d'un bloc, l'un après l'autre.
    scope.querySelectorAll('*').forEach(function (el) {
      var p = el.parentElement;
      if (!p || el.closest(SKIP) || el.classList.contains('rv')) return;
      var d = getComputedStyle(p).display;
      if ((d === 'grid' || d === 'inline-grid') && p.children.length > 1 && p.children.length <= 12 &&
          el.querySelector('img, svg, h2, h3, h4') && visible(el) && !marked(el, scope)) {
        mark(el, 'card');
        list.push(el);
      }
    });

    scope.querySelectorAll(MEDIA + ', ' + TEXT).forEach(function (el) {
      if (el.classList.contains('rv') || el.closest(SKIP) || marked(el, scope) || !visible(el)) return;
      if (el.matches('svg') && el.getBoundingClientRect().width < 80) return;
      if (el.matches('img') && el.parentElement.matches('picture')) return;
      if (el.matches('li') && el.closest('nav, .pagination')) return;
      if (el.matches(MEDIA)) mark(el, 'media');
      else if (el.matches(WORDS) && !el.querySelector('a, button, input') && splitWords(el)) mark(el, 'words');
      else mark(el);
      list.push(el);
    });

    list.forEach(function (el) { io.observe(el); });
  }

  function start() {
    document.querySelectorAll('main#MainContent > .shopify-section, .shopify-section-group-footer-group').forEach(scan);
    // Ce qui est déjà au-dessus de l'écran (retour arrière, ancre) s'affiche d'emblée.
    document.querySelectorAll('.rv').forEach(function (el) {
      if (el.getBoundingClientRect().bottom < 0) { io.unobserve(el); finish(el); }
    });
    requestAnimationFrame(done);
  }

  setTimeout(done, 2500);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
